import classNames from "classnames";

export const thClasses = "border bg-white p-2";
export const tdClasses = "border bg-white p-2 break-words whitespace-normal";
export const centeredTdClasses = classNames(tdClasses, "text-center");
